import { debounce, checkMobileOrDesktopHeader } from './helper';

export function initSidebar() {
  const sidebar = document.querySelector('#sidebar');
  if (!sidebar) return;

  let header = checkMobileOrDesktopHeader();
  const observer = new IntersectionObserver(
    (entries) => {
      entries.forEach((entry) => {
        if (entry.isIntersecting) {
          sidebar.classList.add('translate-x-full');
        } else {
          sidebar.classList.remove('translate-x-full');
        }
      });
    },
    { threshold: 0.33 }
  );

  const changeNavColorOnScroll = debounce(() => {
    header = checkMobileOrDesktopHeader();
    if (header) observer.observe(header);
  }, 200);

  changeNavColorOnScroll();
  window.addEventListener('resize', changeNavColorOnScroll);
}
